import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Divider, Drawer, ListItemButton, ListItemText, MenuItem } from '@mui/material';
import { absurd } from 'fp-ts/function';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NavLink from '../nav-link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var MobileNavLink = function MobileNavLink(_ref) {
  var link = _ref.link,
      container = _ref.container,
      onClick = _ref.onClick;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (link.typename === 'NavBlockLink' || link.typename === 'NavBlockLogoLink') {
    return /*#__PURE__*/_jsx(MenuItem, {
      children: /*#__PURE__*/_jsx(ListItemText, {
        onClick: onClick,
        primary: /*#__PURE__*/_jsx(NavLink, {
          link: link
        })
      })
    });
  }

  if (link.typename === 'NavBlockGroup' || link.typename === 'NavBlockLogoGroup') {
    return /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsxs(ListItemButton, {
        sx: {
          display: 'flex',
          justifyContent: 'space-between'
        },
        onClick: function onClick() {
          return setOpen(true);
        },
        children: [/*#__PURE__*/_jsx(ListItemText, {
          primary: t(link.display)
        }), /*#__PURE__*/_jsx(KeyboardArrowRightIcon, {})]
      }), /*#__PURE__*/_jsxs(Drawer, {
        PaperProps: {
          style: {
            position: 'initial'
          }
        },
        ModalProps: {
          container: container,
          style: {
            position: 'absolute'
          }
        },
        open: open,
        elevation: 0,
        hideBackdrop: true,
        children: [/*#__PURE__*/_jsxs(ListItemButton, {
          sx: {
            display: 'flex',
            alignItems: 'center',
            flexGrow: 0
          },
          onClick: function onClick() {
            return setOpen(false);
          },
          children: [/*#__PURE__*/_jsx(ArrowBackIcon, {
            sx: {
              mr: 1
            }
          }), t(link.display)]
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            pl: 1
          },
          children: link.links.map(function (childLink) {
            return /*#__PURE__*/_jsx(MobileNavLink, {
              container: container,
              link: childLink,
              onClick: onClick
            }, childLink.id);
          })
        })]
      })]
    });
  }

  return absurd(link);
};

var MobileNavLinks = function MobileNavLinks(_ref2) {
  var container = _ref2.container,
      links = _ref2.links,
      handleClosePopover = _ref2.handleClosePopover;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [links.map(function (link) {
      return /*#__PURE__*/_jsx(MobileNavLink, {
        container: container,
        link: link,
        onClick: handleClosePopover
      }, link.id);
    }), /*#__PURE__*/_jsx(Divider, {
      "data-element": "Divider",
      "data-component": "MobileNavLinks",
      "data-source-file": "mobile-nav-links.tsx"
    })]
  });
};

export default MobileNavLinks;